'use strict';

var processInclude = require('./util');
var setdatalayer = require('./gtm/setdatalayer');

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./components/zoom'));
    processInclude(require('./components/video'));
    processInclude(require('./pickupinstore/pdpInstoreInventory'));

    // GTM View Event PDP
    var data = $('.product-detail').data('pdpdetails');
    setdatalayer.PDP(data);
});

require('./thirdParty/jquery.elevateZoom-3.0.8.min');
